import React, { useContext, useState } from 'react';
import { useTheme } from '@material-ui/core';
import ScreenTextContext from '../contexts/ScreenTextContext';

const transformTextForNamePlates = (name) => {
  name = name.toUpperCase();
  if (name.indexOf("\n") > -1 ) {
    const nameParts = name.split("\n");
    nameParts[0] = <tspan x="50%" y="-14.02" key={0}>{nameParts[0]}</tspan>
    nameParts[1] = <tspan x="50%" y="14.02" key={1}>{nameParts[1]}</tspan>
    return nameParts;
  } else {
    return name;
  }
}

export const TeamCard = ({active, focused, showHover, sparkle, team}) => {

  const { screenText } = useContext(ScreenTextContext);  
  
  const theme = useTheme();

  const [hovered, setHovered] = useState(false);

  if (!screenText || !screenText.setUp ) {
    return ''; // Should return error? Loading?
  }
  
  const { teamNames : teamsText } = screenText.global;
  const { label, size } = teamsText[team];
  
  const id = label.replaceAll(" ", "-");

  let colors = {
    text: theme.palette.navyLight2,
    bg: theme.palette.navyDark3,
    border: theme.palette.navy,
  }

  if (active) {
    colors = {
      text: '#FFF',
      bg: theme.palette.redDark,
      border: theme.palette.red,
    }
  }

  if (hovered) {
    colors = {
      text: '#FFF',
      bg: theme.palette.red,
      border: theme.palette.red,
    }
  }

  const handleMouseEnter = () => {
    setHovered(true)
  }

  const handleMouseLeave = () => {
    setHovered(false)
  }

  const displaySparkles = () => {
    const sparkles = [];
    for (let i = 0; i < 5; i++) {
      sparkles.push(
        <li key={i} className="team-card__sparkle">
          <svg xmlns="http://www.w3.org/2000/svg" width="25.195" height="25.195" viewBox="0 0 25.195 25.195" aria-hidden="true">
            <path className="star" d="M24.322,137.513l-2.67-9.928-9.928-2.67,9.928-2.67,2.67-9.928,2.67,9.928,9.928,2.67-9.928,2.67Z" transform="translate(-11.724 -112.318)" fill="#eb4b23"/>
          </svg>
        </li>
      )
    }
    return sparkles;
  }

  return (
    <div 
      className="team-card" 
      aria-labelledby={`team-card-label-${id}`}
      onMouseEnter={showHover ? handleMouseEnter : null} 
      onMouseLeave={showHover ? handleMouseLeave : null}
      style={focused ? { outline: '-webkit-focus-ring-color auto 1px' } : {}}
    >
      
      {sparkle ? 
        <ol className="team-card__sparkles">
          {displaySparkles()}
        </ol>
      : '' }

      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" viewBox="0 0 224 249" aria-hidden="true">
        <image width="224" height="249" href={`${process.env.PUBLIC_URL}/assets/images/teams/${team + (active || hovered || focused ? '-active' : '')}.png`}/>
        {/* force preloading of active image state by loading it out of the viewbox; will get put in the right place on active/hover/focus states */}
        <image width="1" height="1" x="-50%" href={`${process.env.PUBLIC_URL}/assets/images/teams/${team}-active.png`}/>
        <g>
          <rect fill={colors.bg} stroke={colors.border} strokeWidth="3px" x="3" y="169" width="220" height="63"/>
          <text id={`team-card-label-${id}`} x="50%" transform="translate(0 203)" fontFamily="Vox" dominantBaseline="middle" textAnchor="middle" fontSize={(size === 1 || label.indexOf("\n") > -1) ? 26 : 30} fill={colors.text}>
            {transformTextForNamePlates(label)}
          </text>
        </g>
      </svg>
    </div> 
  )
}